import { track, logError } from '@tracking';
import { getLocationMethod } from '@utils/trackingUtils';
import { getSearchId } from '@tracking/services/location.service';
import { getCountryName } from '@shared/selectors';
import getLocationPointAreaName from '@commons/models/LocationPoint/getters/getAreaName';
import { getLocationPointCityName } from '@commons/models/LocationPoint';
import locationToString from '@commons/models/LocationPoint/mappers/toStringWithCityAndCountry';
import { isNullOrUndefined } from '@utils/object';
import getSessionId from '@core/reducers/user/selectors/getSessionId';

const EVENT_NAME = 'address_submitted.finished';

const trackAddressSubmittedFinished = ({ address, success }) => (
  _,
  getState,
) => {
  try {
    const state = getState();
    const searchId = getSearchId();
    const dbSearchGuid = getSessionId(state);
    const country = getCountryName(state);
    const {
      latitude,
      longitude,
      isAddressSubmission,
      mapShown,
      mapClick,
      optionClick,
    } = address || {};

    const searchSuccess =
      !!success &&
      !isNullOrUndefined(latitude) &&
      !isNullOrUndefined(longitude);

    const payload = {
      locationAddress: locationToString(address, country),
      locationLat: latitude,
      locationLon: longitude,
      locationAreaName: getLocationPointAreaName(address),
      locationCity: getLocationPointCityName(address),
      locationMethod: getLocationMethod({ searchedLocation: address }),
      searchSuccess,
      isAddressSubmission: isNullOrUndefined(isAddressSubmission)
        ? true
        : isAddressSubmission,
      mapShown: mapShown || false,
      mapClick: mapClick || false,
      optionClick: optionClick || false,
      searchId,
      dbSearchGuid,
    };
    track(EVENT_NAME, payload, {
      excludeFromCommon: ['locationLat', 'locationLon'],
    });
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackAddressSubmittedFinished;
